module.exports = __webpack_public_path__ + "static/img/jinjichang_3.3f1ce96f.png";